import { CARD_TEXT, CARD_BG, CaseTypes } from '@portalCommon/constants/';
import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export const TopCard = ({ type }: { type: CaseTypes }) => {
  return (
    <div className={cx('card')}>
      <OptimizedImg width={462} className={cx('left')} src={CARD_BG[type]} />
      <div className={cx('right')}>
        <div className={cx('top')}>{CARD_TEXT[type][0]}</div>
        <div className={cx('bottom')}>{CARD_TEXT[type][1]}</div>
      </div>
    </div>
  );
};
